import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { ActivatedRoute } from '@angular/router';
import { REDCRSS_EVENTS } from '../../shared/services/constants/redcross_evemts';
import { FeatureService } from '../shared/services/feature.service';
import { FlowTrackingService } from '../../signup/shared/services/flow-tracking.service';
import { navToB2B } from '../shared/navigation/state/navigation_actions_creator';
import { IAppState } from '../../app_state';
import { AnalyticsTrackingProvider, AuthService } from '@yotpo-ui/core';
import { StorageService } from '../shared/services/storage.service';
import { STORAGE } from '../shared/navigation/constants';
import { take } from 'rxjs/operators';

@Component({
  selector: 'yi-main-panel',
  template: require('./main.panel.component.html'),
  styles: [require('./main.panel.component.scss')]
})
export class MainPanelComponent implements OnInit {

  private currentStep;
  private isWidgetV3: boolean;

  constructor(private redCross: AnalyticsTrackingProvider,
              private store: Store<IAppState>,
              private activatedRoute: ActivatedRoute,
              private featureService: FeatureService,
              private flowTrackingService: FlowTrackingService,
              private authService: AuthService,
              private storageService: StorageService
  ) {}

  ngOnInit() {
    this.store.select(state => state.app.install.navigation).subscribe(items => {
      if (items.navigationItems) {
        this.currentStep = items.navigationItems.filter(item => item.active === true)[0];
      }
    });

    this.store.select(state => state.app.install.integrate).pipe(take(1)).subscribe(
      items => {
        this.isWidgetV3 = items.hasWidgetV3;
      });
  }

  skipInstallation() {
    this.flowTrackingService.MobilePageCompleted(this.activatedRoute.snapshot, 'skip installation');

    if (this.currentStep?.name === 'NAVIGATION_TABS.CUSTOM_EMAILS') {
      this.redCross.identifiedTrack(REDCRSS_EVENTS.ACTIVATION_STEP, {
        product: REDCRSS_EVENTS.PRODUCT,
        stepName: REDCRSS_EVENTS.COLLECT_REVIEWS,
        stepNum: 1,
        status: REDCRSS_EVENTS.SKIP,
        isWidgetV3: this.isWidgetV3
      });
    } else if (this.currentStep?.name === 'NAVIGATION_TABS.CUSTOM_WIDGETS') {
      this.redCross.identifiedTrack(REDCRSS_EVENTS.ACTIVATION_STEP, {
        product: REDCRSS_EVENTS.PRODUCT,
        stepName: REDCRSS_EVENTS.CUSTOMIZE_WIDGET,
        stepNum: 2,
        status: REDCRSS_EVENTS.SKIP,
        isWidgetV3: this.isWidgetV3
      });
    } else {
      this.redCross.identifiedTrack(REDCRSS_EVENTS.ACTIVATION_STEP, {
        product: REDCRSS_EVENTS.PRODUCT,
        stepName: REDCRSS_EVENTS.INTEGRATE,
        stepNum: 3,
        status: REDCRSS_EVENTS.SKIP,
        isWidgetV3: this.isWidgetV3
      });
    }

    this.redCross.track(REDCRSS_EVENTS.CTA_CLICK, {
      ctaType: 'Button',
      ctaText: 'Skip Installation'
    });

    this.redCross.track(REDCRSS_EVENTS.CTA_CLICK, {
      ctaLocation: 'Reviews Onboarding',
      ctaName: 'Integrate',
      ctaText: 'Skip Installation'
    });

    this.featureService.setFeatureSettings('InstallationV2',
      {
        settings: {
          install_status: 'Skipped'
        }
      }
    ).subscribe();

    const creds = this.authService.getCredentials();
    this.storageService.set(STORAGE.APP_KEY, creds.appKey);
    this.storageService.set(STORAGE.UTOKEN, creds.utoken);

    this.store.dispatch(navToB2B());
  }

}
